export interface ITaskItem {
    description: string;
    iconName: string;
    name: string;
}

export const tasks: ITaskItem[] = [
    {
        description: "Build, test, package, or publish a dotnet application",
        iconName: "Home",
        name: ".NET Core"
    },
    {
        description: "Acquires a specific version of .NET Core from internal installer",
        iconName: "Phone",
        name: ".NET Core Tool Installer"
    },
    {
        description: "Sign and align Android APK Files",
        iconName: "Lock",
        name: "Android Signing"
    },
    {
        description: "Distribute app builds to testers and users via AppCenter",
        iconName: "Globe",
        name: "App Center Distribute"
    },
    {
        description: "Test app packages with App Center",
        iconName: "Home",
        name: "App Center Test"
    },
    {
        description: "Archive files using compression formats",
        iconName: "Phone",
        name: "Archive Files"
    },
    {
        description: "Update Azure App Services on Windows, Web Applications, etc.",
        iconName: "Lock",
        name: "Azure App Service Deploy"
    }
];
